/**
 * 数据中心新sdk统计公共组件-by lf
 *
 * sdk文档说明地址：https://doc.linghit.io/web/#/25/4209
 *
 * */

// 数据中心统计
import {commonFn} from './common.js';
let hasSense = false;
let hasSdkInit = false; //sdk是否已经初始化
let otherPropertyOpts = {};
const SDK_CDN = 'https://aicdn.tingzhi66.cn/sense-sdk/latest/sense.sdk.min.js';

const trackQueue = [];

window._senseTrack = async (eventName, properties = {}) => {
	if (!eventName || !hasSense) return;


	if (!hasSdkInit) {
		trackQueue.push({
			eventName,
			properties,
		});
		return;
	}

	properties = {
		source: location.href,
		...properties
	};
	// console.log(`上报`, eventName, properties && JSON.stringify(properties, null, '\t'));
	window.sense.track(eventName, properties);
};

const senseInit = async (
	appId = 'F00',
	appVersion = '',
	product_id = '159714467600000010',
	otherAttr = {},
	propertyOpts = {}
) => {
	hasSense = true;
	otherPropertyOpts = propertyOpts;
	await commonFn.loadScript(SDK_CDN);
	// 初始化参数
	const channel = commonFn.getParams()['channel'] || localStorage.getItem('channel') || '';
	const object = {
		app_id: appId, // 业务线id
		channel, // 渠道号
		single_page: true, // 是否单页应用
		attr: {
			$app_version: appVersion,
			...otherAttr
		},
		auto_track: true,
		product_id: product_id,
		user_center_id: commonFn.getParams()['u_id'] || '',
		show_log: false // 发送数据时，是否在控制台显示日志信息
		// env: "", // 环境 台湾 tw 美国 mx
	};

	try {
		// 轮循sdk
		const timer = setInterval(() => {
			console.log(`轮循sdk`);
			if (!window.sense) {
				return;
			}

			window.sense.init(object);
			clearInterval(timer);
			setTimeout(() => {
				hasSdkInit = true;
				trackQueue.forEach(item => {
					window._senseTrack(item.eventName, item.properties);
				});
				trackQueue.splice(0);
			}, 500);
		}, 1000);
	} catch (error) {
		console.log(error);
	}
};

senseInit('S49', 'H5', '159714467600000010', {});



// WEBPACK FOOTER //
// ./src/common/js/senseSdk.js